import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'toCustomStringAnnoMese'})
export class ToCustomStringAnnoMesePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    const element = value;
    if (element) {
      return this.getAnnoMese(element);
    }
    return 'N.D.';
  }

  getAnnoMese(annoMese: number): string {
    const year = Number(annoMese.toString().substring(0, 4));
    const month = Number(annoMese.toString().substring(4, 6));

    const options = {month: 'long', year: 'numeric'};
    const parsedYearMonth = new Date(year, month - 1);

    return parsedYearMonth.toLocaleDateString('en-US', options);
  }
}
